import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Category from './../models/Category';
// import { HOTEL } from './../constants/Define';
import { getDummyData } from './../utils/commonUtils';


export function getCategories(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CATEGORY_LIST,
        params: params,
        parser: categoriesDataParser,
    }).get();
}

export function getAllCategories(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CATEGORY_LIST_ALL,
        params: params,
        parser: (data) => data.data,
    }).get();
}

export function getCategoryDetail(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CATEGORY_DETAIL,
        endpointParams: { id },
        parser: (data) => new Category(data.data),
    }).get();
}

export function createCategoryDetail(category) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CATEGORY_ACTION,
        parser: (data) => new Category(data.category),
    }).post(category.export());
}

export function updateCategoryDetail(category) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CATEGORY_ACTION,
        // endpointParams: { id: category.id },
        parser: (data) => new Category(data.category),
    }).put(category.export());
}

export function deleteCategoryDetail(category) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CATEGORY_DETAIL,
        endpointParams: { id: category.id },
        // parser: (data) => new Category(data.category),
    }).delete();
}

export function createCategoryTranslate(category) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CATEGORY_TRANSLATE_CREATE,
    }).post(category.export(true).translate());
}

export function updateCategoryTranslate(category) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CATEGORY_TRANSLATE_UPDATE,
    }).put(category.export(true).translate());
}

export function deleteCategoryTranslate(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CATEGORY_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

const categoriesDataParser = (data) => ({
    categories: (data.data.result || []).map(item => new Category(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
});



